export enum WirecardTransactionType {
	AUTHORIZATION = 'authorization',
	AUTHORIZATION_ONLY = 'authorization-only',
	PURCHASE = 'purchase',
	CAPTURE_AUTHORIZATION = 'capture-authorization',
	REFERENCED_AUTHORIZATION = 'referenced-authorization',
	REFERENCED_PURCHASE = 'referenced-purchase',
	DEBIT = 'debit',
	PENDING_DEBIT = 'pending-debit',
	REFUND_DEBIT = 'refund-debit',
	TOKENIZE = 'tokenize',
}
